import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { DriveContextMenuCoordinator } from './drive-context-menu.coordinator';
import { DriveSelectionQuery } from './drive-selection.query';
import { DriveMoveState, DriveSummaryState } from './drive-viewer.state';

export class DriveSummaryCoordinator {
  constructor(
    private readonly state: DriveSummaryState,
    private readonly move: DriveMoveState,
    private readonly selection: DriveSelectionQuery,
    private readonly contextMenu: DriveContextMenuCoordinator,
    private readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly notifications: NotificationService,
    private readonly translate: (key: string) => string
  ) {}

  openFromContext(): void {
    const item = this.move.contextMenuItem;
    if (!item || item.type === 'folder') {
      this.contextMenu.close();
      return;
    }
    const batch = this.selection.isSelected(item.id) ? this.selection.selectedFiles() : [item];
    const sources = batch
      .filter((file) => file.type !== 'folder' && !!file.documentId)
      .map((file) => ({ documentId: String(file.documentId), filename: file.name }));
    this.contextMenu.close();
    if (!sources.length) {
      this.notifications.addNotification({
        type: 'warning', message: this.translate('drive.generateSummary.noDocuments')
      });
      return;
    }
    this.state.summarySources = sources;
    if (!this.state.generateSummaryDialogTpl) return;
    this.state.summaryDialogRef = this.dialog.open(this.state.generateSummaryDialogTpl, {
      width: '460px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      panelClass: 'drive-document-dialog-panel'
    });
    this.state.summaryDialogRef.afterClosed().subscribe(() => {
      this.state.summaryDialogRef = undefined;
    });
  }

  confirm(): void {
    const suggestedSources = this.state.summarySources.map((source) => ({ ...source }));
    this.state.summaryDialogRef?.close();
    this.router.navigate(['/generate'], { state: { suggestedSources } });
  }
}
